var map = {
	"./432-ai.png": 873,
	"./arrow.png": 4000,
	"./book.png": 2308,
	"./box.png": 9976,
	"./chat.png": 3193,
	"./chat_icon.png": 6541,
	"./cloud.png": 1224,
	"./croppedchat.gif": 1483,
	"./dashboard.png": 5879,
	"./dot.png": 2894,
	"./get_started_bg.png": 3075,
	"./googleMeet.png": 83,
	"./left_leaf.png": 1761,
	"./live_chat.png": 7496,
	"./mobile.png": 8581,
	"./pluse.png": 3078,
	"./right_leaf.png": 6090,
	"./triangle.png": 1199,
	"./video_icon.png": 860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5563;